import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Col, Row, Divider, Avatar, Typography, Skeleton } from 'antd';
import { ThemeContext } from '../Context/ThemeContext';
import { ProfileContext } from '../Context/ProfileContext';

const { Text } = Typography;
const User = (props) => {
  const history = useHistory();
  const { theme } = useContext(ThemeContext);
  const { followUser } = useContext(ProfileContext);

  const skeletions = [1, 2, 3].map((i) => {
    return (
      <div key={i}>
        <Row justify='center' align='middle'>
          <Col xs={4} sm={2} lg={4}>
            <Skeleton
              loading={props.loading}
              paragraph={false}
              title={false}
              active
              avatar={{
                shape: 'circle',
                active: true,
              }}
            />
          </Col>
          <Col xs={14} sm={8} lg={8}>
            <Skeleton
              loading={props.loading}
              active
              title={false}
              avatar={false}
              paragraph={{
                rows: 2,
              }}
            />
          </Col>
          <Col xs={6} sm={2} lg={4}>
            <Skeleton
              loading={props.loading}
              title
              paragraph={false}
              active
              avatar={false}
            />
          </Col>
        </Row>
        <Divider />
      </div>
    );
  });

  return (
    <div>
      {props.loading
        ? skeletions
        : props.users.map((item) => {
            return (
              <div key={item.app_profile_uid}>
                <Row justify='center' align='middle'>
                  <Col xs={4} sm={2} lg={2}>
                    <Avatar
                      icon={
                        <img
                          src={item.picture.replace('s96-c', 's512-c', true)}
                          alt={item.name.fullName}
                        />
                      }
                    />
                  </Col>
                  <Col xs={14} sm={6} lg={8}>
                    <Text
                      style={{
                        color: theme.drawer.text,
                        textAlign: 'left',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        history.push(`/${item.app_profile_uid}`);
                      }}
                      strong
                    >
                      {item.name.fullName} <br />
                      <Text
                        type='secondary'
                        style={{
                          padding: 0,
                          fontSize: '10px',
                          color: theme.drawer.secondaryText,
                        }}
                      >
                        {item.bio}
                      </Text>
                    </Text>
                  </Col>
                  <Col
                    xs={6}
                    sm={4}
                    lg={4}
                    style={{
                      color: theme.header.text,
                      textAlign: 'right',
                    }}
                  >
                    {item.current_user_follows ? (
                      <Button
                        size='small'
                        type='primary'
                        onClick={() => {
                          followUser(item.app_profile_uid);
                        }}
                      >
                        Following
                      </Button>
                    ) : (
                      <Button
                        size='small'
                        onClick={() => {
                          followUser(item.app_profile_uid);
                        }}
                      >
                        Follow
                      </Button>
                    )}
                  </Col>
                </Row>
                <Divider />
              </div>
            );
          })}
    </div>
  );
};

export default User;
